import logo from "./logo.png";

const images = {
    logo
}

export default images;
